<template>
    <div class="drag"><i>&#xe906;</i></div>
    <div class="checkbox" v-if="isFinished">
      <i @click="handleClick">&#xe901;</i>
    </div>
    <div class="checkbox" v-else>
      <i @click="handleClick">&#xe900;</i>
    </div>
    <input-box :text="item.todo_content" :is-finished="isFinished" :item-id="item.item_id" @input-box-change="handleInputBoxChange" :index="index"></input-box>
</template>

<script>
  import InputBox from './input-box'
  import {deleteTodo, updateTodo} from 'src/vuex/actions'
  export default {

    name: 'todo-item',

    components: {
      InputBox
    },

    vuex: {
      actions: {
        deleteTodo,
        updateTodo
      }
    },

    props: {
      item: Object,
      index: Number
    },

    data() {
      return {
        isFinished: this.item.todo_status == 'completed'
      }
    },

    computed: {
    },
    methods: {
      handleClick() {
        this.isFinished = !this.isFinished
        // this.$dispatch('change-status', this.isFinished)
        var status = this.item.todo_status == 'completed' ? 'uncompleted' : 'completed'
        this.updateTodo(this.item.id,{
          status: status
        })
      },
      handleInputBoxChange(text, isBlur) {
        // alert(1+(text == ''))
        // alert(1+(text == '<br>'))
        if (text == '' || text == '<br>') {
          this.deleteTodo(this.item.id)
          this.$dispatch('delete-succeed', this.index)
        } else {
          this.updateTodo(this.item.id,{
            content: text
          })
          this.$dispatch('update-succeed', this.index, isBlur)
        }
      }

    }
  }
</script>



/** WEBPACK FOOTER **
 ** todo-item.vue?4a2e9f88
 **/